export default {
  title: 'Réinitialiser le mot de passe',

  labels: {
    submit: 'Valider',
    passwordConfirmation: 'confirmation du mot de passe'
  }
}
